<div
  *ngIf="control"
  class="dict-dobry-agent-blog-tags"
>
  <mat-form-field class="dict-dobry-agent-blog-tags__select">
    <mat-label>{{ label }}</mat-label>

    <mat-select
      [formControl]="control"
      [required]="required"
      [multiple]="true"
      (selectionChange)="onSelectionChange($event)"
    >
      <mat-option>
        <ngx-mat-select-search
          [formControl]="filterControl"
          placeholderLabel="Wyszukaj tag..."
          noEntriesFoundLabel="Nie znaleziono tagu"
        >
        </ngx-mat-select-search>
      </mat-option>

      <mat-option
        *ngIf="loading"
        disabled
      >
        <div class="tag-loading">
          <mat-spinner diameter="20"></mat-spinner>
          <span>Wczytywanie...</span>
        </div>
      </mat-option>

      <mat-option
        *ngFor="let tag of items"
        [value]="tag.uuid"
      >
        {{ tag.name }}
      </mat-option>

      <mat-option
        *ngIf="hasMore"
        class="tag-load-more-option"
        (click)="loadMore($event)"
      >
        <div class="tag-load-more">
          <mat-spinner
            *ngIf="loadingMore"
            diameter="20"
          ></mat-spinner>

          <mat-icon *ngIf="!loadingMore">
            expand_more
          </mat-icon>

          <span>
            {{ loadingMore ? 'Wczytywanie...' : 'Wczytaj więcej' }}
          </span>
        </div>
      </mat-option>
    </mat-select>

    <button
      *ngIf="hasSelectedTags && !required && !control.disabled"
      matSuffix
      mat-icon-button
      type="button"
      aria-label="Wyczyść tagi"
      (click)="clearValue(); $event.stopPropagation()"
    >
      <mat-icon>close</mat-icon>
    </button>

    <mat-error *ngIf="control.hasError('required')">
      To pole jest wymagane
    </mat-error>

    <mat-error *ngIf="control.hasError('backendError')">
      {{ control.getError('backendError') }}
    </mat-error>
  </mat-form-field>

  <mat-chip-list
    *ngIf="hasSelectedTags && !hiddenChips"
    class="dict-dobry-agent-blog-tags__chips"
    aria-label="Wybrane tagi"
  >
    <mat-chip
      *ngFor="let tag of selectedItems"
      [removable]="!control.disabled"
      (removed)="removeTag(tag)"
    >
      {{ tag.name }}

      <mat-icon
        *ngIf="!control.disabled"
        matChipRemove
      >
        cancel
      </mat-icon>
    </mat-chip>
  </mat-chip-list>
</div>
